import React, { useState , useEffect} from "react";
import styles from "./main.module.scss"
import temperatireImg from "../../app/images/temperature.png"
import humidityImg from "../../app/images/humidity.png"
import spinnerImg from "../../app/images/spinner.png"
import axios from "axios";
import { getAllDevices } from "../../app/data/api";

const API_BASE_URL = "https://api.drymatec.de/api/user";

type DeviceData = {
  id: string;
  temperature: number;
  humidity: number;
  resistance: number;
};
interface DeviceDataType {
  deviceId: string;
  temperature: number;
  humidity: number;
  resistance: number;
  updatedAt: string;
}
interface MainProps {
  setDeviceDateArr: React.Dispatch<React.SetStateAction<DeviceDataType[] | null>>;
}

const Main: React.FC<MainProps> = ({ setDeviceDateArr }) => {
  const [userId, setUserId] = useState<string | null>(null);
  const [username, setUsername] = useState<string | null>(null);
  const [deviceNum, setDeviceNum] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [userDevice, setUserDevice] = useState<string | null>(null);
  const [error, setError] = useState("");
  const [deviceDate, setDeviceDate] = useState<DeviceData | null>(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));

        setUserId(payload.id);

      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/${userId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setUsername(response.data.username);
        setDeviceNum(response.data.device)
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (userId) {
      fetchUserData();
    }
  }, [userId]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        if (!deviceNum) return; // Ensure deviceNum is available

        const devicesData = await getAllDevices();
        console.log("All Devices:", devicesData);

        const matchedDevice = devicesData.find((device: any) => device.deviceId === deviceNum);

        if (matchedDevice) {
          setUserDevice(matchedDevice._id);
          console.log("Matched Device ID:", matchedDevice._id);
        } else {
          console.warn("No matching device found for deviceNum:", deviceNum);
        }
      } catch (error) {
        console.error("Error fetching devices:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [deviceNum]);

  useEffect(() => {
    if (!userDevice) return;

    const fetchDeviceData = async () => {
      try {
        const API_URL = "https://api.drymatec.de/api/device-data";
        const response = await fetch(`${API_URL}/${userDevice}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (!response.ok) throw new Error("Error loading device data.");
        const data = await response.json();
        const lastItem = data[data.length - 1];
        setDeviceDateArr(data)
        setDeviceDate(lastItem)
        console.log("Device Data:", lastItem);
      } catch (error) {
        setError(error instanceof Error ? error.message : "An unknown error occurred.");
      } finally {
        setLoading(false);
      }
    };

    fetchDeviceData();
  }, [userDevice]);

  return (
   <div className={styles.wrapper}>
      <h3 className={styles.title}>Welcome, {username}</h3>
      <p className={styles.par}>Everything is under control! Your DryMaTec® system is operating smoothly.</p>
      <ul className={styles.statsList}>
        <li className={styles.statsItem}>
           <div className={styles.imgBox}>
              <img src={humidityImg} alt="humidityImg"/>
           </div>
           <p className={styles.text}>Humidity</p>
           <p className={styles.num}>{deviceDate?.humidity}%</p>
        </li>
        <li className={styles.statsItem}>
           <div className={styles.imgBox}>
              <img src={temperatireImg} alt="temperatireImg"/>
           </div>
           <p className={styles.text}>Temperature</p>
           <p className={styles.num}>{deviceDate?.temperature}°C</p>
        </li>
        <li className={styles.statsItem}>
           <div className={styles.imgBox}>
              <img src={temperatireImg} alt="temperatireImg"/>
           </div>
           <p className={styles.text}>Messure</p>
           <p className={styles.num}>{deviceDate?.resistance}%</p>
        </li>
        <li className={styles.statsItem}>
           <div className={styles.imgBox}>
              <img src={spinnerImg} alt="spinnerImg"/>
           </div>
           <p className={styles.text}>Status</p>
           <p className={styles.activeText}>ACTIVE</p>
           <p className={styles.waitingText}>WAITING</p>
           <p className={styles.inactiveText}>INACTIVE</p>
        </li>
      </ul>
   </div>
  );
};

export default Main;
